module.exports = __webpack_public_path__ + "img/Frame_3.b18b8b7f.png";